import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import QuestionFormBase from '../../components/forms/QuestionFormBase';
import * as api from '../../api/listeningQuestionApi';

const ListeningQuestionForm = () => {
  const { listeningId, questionSetId, questionId } = useParams();
  const location = useLocation();
  const { part, type, questionCount, startQuestionNumber = 1, answerOptions = [] } = location.state || {};

  return (
    <QuestionFormBase
      parentId={listeningId}
      questionSetId={questionSetId}
      questionId={questionId}
      section={part}
      sectionKey="part"
      sectionLabel="Part"
      initialType={type}
      questionCount={questionCount}
      startQuestionNumber={startQuestionNumber}
      basePath="/listenings"
      api={api}
      answerOptions={answerOptions}
    />
  );
};

export default ListeningQuestionForm;
